<template>
  <StepItem
    format="form"
    title="Plan & Payment"
    subtitle="This page is encrypted for your security | Step 3 of 3"
    show-lock
    without-buttons
    form-max-width-class="w-screen-lg"
    :is-ready-for-next-step="true">
      <AnimationLoading v-if="isCreatingCompany" dark fullscreen
                        :text="`Creating ${store.name || 'Company'} • Do Not Close This Page`"/>
      <BillingPlanSelector default-is-billing-yearly
                           :billing-plans="store.billingPlans"
                           v-model:billingPlanId="store.billingPlanId"
                           v-model:cycleInterval="store.cycleInterval"
                           :is-enterprise="store.locations.length > 1"
                           @update:billingPlanId="handleNextStep"
                           show-contact-sales/>
    <FormButton @click="handlePrevStep" color="secondary" class="block mx-auto mt-24">
      Back
    </FormButton>
  </StepItem>
</template>

<script setup>
import AnimationLoading from "./AnimationLoading.vue";
import StepItem from "./StepItem.vue";
import BillingPlanSelector from "./BillingPlanSelector.vue";
import {useCompanyAccountCreateStore} from "../stores/CompanyAccountCreateStore";
import {useAccountStore} from "../stores/AccountStore.js";
import {computed, onBeforeMount, ref} from "vue";
import FormButton from "./FormButton.vue";

const store = useCompanyAccountCreateStore();
const accountStore = useAccountStore();

const emits = defineEmits(["complete", "prev-step"]);
const isCreatingCompany = ref(false);

const prevStepCount = computed(() => {
  if (accountStore.isLoggedIn) return 4;
  return 1;
});

const handlePrevStep = () => emits("prev-step", prevStepCount.value);

const handleNextStep = async () => {
  if (!store.billingPlanId) return;

  store.setFurthestStep(3, "Select a Plan");

  const selectedPlan = store.billingPlans.find(p => p.id === store.billingPlanId);
  const isFreePlan = selectedPlan?.planType === "free" && store.locations.length === 1;

  if (isFreePlan) {
    if (!store.billingEmail) {
      store.billingEmail = store.email || store.existingEmail;
    }
    isCreatingCompany.value = true;
    await store.createCompany((wasSuccessful, error = null) => {
      isCreatingCompany.value = false;
      if (wasSuccessful && !error) {
        accountStore.fetchUserAccount();
        emits("complete", 2); // skip Step 7 (payment) for free plan
      }
    });
  } else {
    emits("complete"); // proceed to Step 7 (payment) for paid plan
  }
};

onBeforeMount(() => store.getBillingPlans());
</script>
